import cookies from './cookies';
const compensaPopup = {
    init() {
        const popup = document.querySelector('.compensa-popup');

        if ( ! popup ) return;

        this.popupActions( popup, '.js-compensa-popup-close' );
        this.popupActions( popup, '.main-button' );

        if ( cookies.getCookie('compensa-popup') ) {
            return;
        }

        this.openPopup( popup );
    },

    popupActions( popup, selector ) {
      const closeTriggers = popup.querySelectorAll(selector);

      if ( ! closeTriggers.length ) return;

      closeTriggers.forEach( close => {
          close.addEventListener('click', () => compensaPopup.closePopup( popup ));
      })
    },

    openPopup( popup ) {
        popup.classList.add('active');
    },

    closePopup( popup ) {
        popup.classList.remove('active');

        cookies.setCookie('compensa-popup', true, 1)
    }
}

export default compensaPopup;
